import React from "react";
import type { CipherText } from "@b2bportal/purchase-api";
import { Environment } from "@hopper-b2b/utilities";

import config from "../../../utils/config";
import "./styles.scss";

export interface IBypassUberPaymentsButton {
  priceQuoteCipherText: CipherText;
  goToNextStep: (paymentSessionToken: string, quoteId: CipherText) => void;
  goToPrevStep: () => void;
}
export const BypassUberPayments = ({
  priceQuoteCipherText,
  goToNextStep,
  goToPrevStep,
}: IBypassUberPaymentsButton) => {
  const triggerMockPaymentEvent = () => {
    const PAYMENT_SESSION_TOKEN = "00000000-0000-0000-0000-000000000000";
    goToNextStep(PAYMENT_SESSION_TOKEN, priceQuoteCipherText);
  };

  const bypassUberPayments = config.ENV !== Environment.production;

  return bypassUberPayments ? (
    <div className="mock-button-container">
      <button className="mock-button" onClick={goToPrevStep}>
        Previous Step
      </button>
      <button className="mock-button" onClick={triggerMockPaymentEvent}>
        Click to pay (DEV)
      </button>
    </div>
  ) : null;
};
